import { ThemeProps as Prop, ColorProfiles } from '@powdr/constants';

export const altTheme = {

};
